import React from "react";
import { withStyles } from '@material-ui/styles';

import pageStyles from "../../styles/page_styles.js";
import { infoPageStyles } from "../base_info_page.js";
import LoadNewsletterEmailsUseCase from "../../../use_cases/admin/newsletters/emails/load_newsletter_emails_use_case.js"

import {
  Card,
  CardContent,
  TextareaAutosize,
} from '@material-ui/core';

const styles = theme => ({
  textarea: {
    width: "100%"
  }
});

class NewsletterEmailsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: ''
    }
  }

  componentDidMount() {
    LoadNewsletterEmailsUseCase.execute()
    .then(result => {
      this.onLoadStatsSuccess(result);
    })
    .catch(result => {
      this.props.showServerErrorIfNeed(result);
    });
  }

  onLoadStatsSuccess(result) {
    const { emails } = result.data;
    this.setState({
      emails
    });
  }

  render() {
    const { classes } = this.props;

    const { emails } = this.state;

    return <div className = { classes.page }
                ref = { (ref) => this.scrollContainer = ref }>
      <div className = { classes.pageContent }
           ref = { (ref) => this.scrollContent = ref }  >
        <Card>
          <CardContent className = { classes.cardContent }>
            <TextareaAutosize className = { classes.textarea }
            defaultValue={emails} />
          </CardContent>
      </Card>
      </div>
    </div>
  }
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...styles(theme),
  }),
  { withTheme: true }
)(NewsletterEmailsPage);